export class AppUrls {
  public static Root = '';
  public static Client = 'client';
}
